var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 12H4M12 17H4M20 7H4","stroke":_vm.color,"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }